import { useEffect, useState } from "react"
import { signInWithPopup } from "firebase/auth"
import { auth } from "../firebase/config"
import { useAuthContext } from "../context/AuthContext"
import { useNavigate } from "react-router-dom"
import instance from "instances/axios"
import axios from "axios"

export const useSocialSignup = (provider) => {
  // State variables to manage sign-up process
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [isCancelled, setIsCancelled] = useState(false)
  const navigate = useNavigate()

  // Accessing the authentication context's dispatch function
  const { dispatch, user } = useAuthContext()

  const createReward = async (data) => {
    console.log(data, "group name")
    try {
      const currentDate = new Date()
      if (currentDate?.getHours() <= 6 && currentDate?.getHours() >= 5) {
        const payload = {
          userid: user.userid,
          reward_amount: 0.02,
          reward_date: currentDate,
        }
        const send = await instance.post(`/reward/create`, payload)
      } else {
        alert("Reward creation is allowed only before 6 AM.")
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Function to initiate the social sign-up process
  const signInWithSocial = async (userData) => {
    setError(null)
    setIsPending(true)

    try {
      const res = await signInWithPopup(auth, provider)
      console.log(res)
      userData.photourl = res.user.photoURL
      userData.email = res.user.email
      userData.createdtime = new Date().toISOString()
      userData.createdat = new Date().getTime()
      userData.accesstoken = res.user.accessToken
      userData.lastloginat = res.user.metadata.lastLoginAt
      userData.lastsignintime = res.user.metadata.lastSignInTime
      const groups = await instance.get("/groups").then((res) => {
        return res.data.data
      })
      // const groupNames = ['A', 'B', 'C', 'D'];
      // const groupLinks = [
      // 	'https://t.me/+_pzOk7YVH1QxNTAy',
      // 	'https://t.me/+8Lm0CGFVNC1lMGRi',
      // 	'https://t.me/+unQfh9GV9Ek5MmVi',
      // 	'https://t.me/+a23D3a32oK8wMWEy',
      // ];
      const groupIndex = Math.floor(Math.random() * groups.length)

      // userData.groupName = groupNames[groupIndex];
      // userData.groupLink = groupLinks[groupIndex];
      userData.group_id = groups[groupIndex]?.group_id
      userData.group = groups[groupIndex]
      userData.rewards = groupIndex === 0 ? 100 : 0
      userData.ispaid = false
      userData.iskickoff = false
      userData.wallet = ""
      let isExist = false
      console.log(userData)

      const checkIsUserExist = () => {
        return new Promise(async (resolve, reject) => {
          const data = await instance
            .get("/users/")
            .then((res) => res.data.data)
            .catch((error) => {
              console.error(error)
            })
          if (!!data) {
            data.forEach(async (userDataFromDB) => {
              if (userDataFromDB.email === res.user.email) {
                if (userDataFromDB.iskickoff === true) {
                  userData = userDataFromDB
                  isExist = true
                  resolve(userDataFromDB)
                } else {
                  isExist = true
                  const updates = {}
                  updates["users/" + userDataFromDB.userindex] = {
                    ...userDataFromDB,
                    ...userData,
                  }
                  await instance
                    .put(`/users`, updates[`users/${userDataFromDB.userindex}`])
                    .then(() => {
                      resolve({
                        ...userDataFromDB,
                        ...userData,
                      })
                    })
                    .catch((error) => {
                      console.log(error)
                    })
                }
              }
            })
            if (!isExist) {
              userData.userindex = data.length
              await instance
                .post(`/users/`, userData)
                .then(async () => {
                  resolve(userData)
                  const currentDate = new Date()
                  const daysInMonth = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth() + 1,
                    0
                  ).getDate()
                  const getUpTimeData = Array.from({ length: daysInMonth }, (_, index) => ({
                    Day: (index + 1).toString(),
                    Time: new Date(currentDate.getFullYear(), currentDate.getMonth(), index + 1),
                    Checked: null,
                  }))
                  await axios
                    .post("https://challengebackend-production.up.railway.app/getuptime/create", {
                      athlete_id: userData.userindex,
                      userid: userData.userindex,
                      get_up_time: getUpTimeData,
                    })
                    .then((res) => {
                      console.log(res.data)
                    })
                    .catch((e) => {
                      console.log("Error: ", e.message)
                    })
                })
                .catch((error) => {
                  console.log(error)
                  reject(error)
                })
            }
          } else {
            console.log("Data not found")
            resolve(userData)
          }
        })
      }
      checkIsUserExist().then((result) => {
        dispatch({ type: "LOGIN", payload: result })
        navigate("/app_download")
      })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } catch (err) {
      setError(err.message)
      setIsPending(false)
    }
  }

  // Effect hook to set isCancelled to true when component unmounts
  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  // Return values and functions for component usage
  return { error, isPending, signInWithSocial }
}
